module.exports = __webpack_public_path__ + "img/33.970ded97.png";